import { GetResponse, GetResponseData } from '@customTypes/api/Notification';
import { Endpoints, ServiceAPI } from '@service/index';

import { useQuery } from '../helper/useQuery';

const useGetNotification = (enabled = true) => {
  return useQuery<GetResponseData>(
    [],
    () =>
      ServiceAPI.get<null, GetResponse>(Endpoints.Notification()).then(
        response => response.data.data,
      ),
    {
      refetchIntervalInBackground: true,
      refetchInterval: 30 * 60 * 1000, // refetch every 30 minutes
      staleTime: 60 * 1000,
      cacheTime: 60 * 1000,
      enabled,
    },
  );
};

export default useGetNotification;
